import { render, staticRenderFns } from "./CardDetalhesProduto.vue?vue&type=template&id=842a084e&scoped=true"
import script from "./CardDetalhesProduto.vue?vue&type=script&lang=js"
export * from "./CardDetalhesProduto.vue?vue&type=script&lang=js"
import style0 from "./CardDetalhesProduto.vue?vue&type=style&index=0&id=842a084e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842a084e",
  null
  
)

export default component.exports